import Message from './Message';

export default (function (w, d) {
    'use strict';

    function RemoveFromWishlistButton() {
        this.init();
    }

    RemoveFromWishlistButton.prototype.init = function () {
        $(document).on('click', '.wish-break', function(){
            var wishlist_product_id = $(this).attr('data-product-id');
            var url = $(this).attr('data-action');
            var $this = $(this);

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.post(url, { product_id: wishlist_product_id }, function(response) {
                if (response.status === 'success') {
                    $('.wish-wrap').each(function(e){
                        if($(this).find('.add-wish').data('product-id') == response.product_id){
                            $(this).find('.count').text(response.count);
                        }
                    });
                    if (response.count_total > 0) {
                        $('.wishlist-count').text('(' + response.count_total + ')');
                    } else {
                        $('.wishlist-count').text('');
                    }
                    const removedItem = $('.wish-break[data-product-id="' + wishlist_product_id + '"]');
                    removedItem.parents('.item').remove();
                } else {
                    new Message(response.message, 'error');
                }
            });
        });
    }

    return RemoveFromWishlistButton;
}(window, document));

